import { useEffect, useRef, useState } from 'react'

const useNavigationDirection = ({ routes = [], currentRoute }) => {
  const previousRoteRef = useRef(currentRoute)
  const [direction, setDirection] = useState(1)

  useEffect(() => {
    const prevIndex = routes.indexOf(previousRoteRef.current)
    const currentIndex = routes.indexOf(currentRoute)

    if (prevIndex > currentIndex) {
      setDirection(-1)
    } else {
      setDirection(1)
    }

    previousRoteRef.current = currentRoute
  }, [currentRoute, routes])

  return {
    direction: direction,
  }
}

export default useNavigationDirection
